import styled from 'styled-components';
import { Select } from 'antd';

export const SelectTab = styled(Select)`
  width: ${props => (props.filterSelect ? '100%' : '302px')};
  /* added for IE */
  vertical-align: middle;
  /* added for IE */
  height: 100%;
  &.ant-select-focused {
    border: 1px solid #505050 !important;
    outline-color: #505050 !important;
    outline-width: 1px !important;
    box-shadow: none !important;
 }
 & .ant-select-selection:focus, 
 & .ant-select-selection--multiple:focus, 
 &.ant-select-focused:not(.grantSelectBox) .ant-select-selection {
  border: 1px solid #d9d9d9 !important;
  outline: none !important;
  box-shadow: none !important;
 }

  .ant-select-selection {
    border-radius: 0px;
  }
  .ant-select-selection-selected-value {
    font-size: 16px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    letter-spacing: normal;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    color: #505050;
    @media only screen and (min-width: 320px) and (max-width: 991px){
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-select-dropdown
    .ant-select-dropdown--single
    .ant-select-dropdown-placement-bottomLeft,
  .ant-select-dropdown
    .ant-select-dropdown--multiple
    .ant-select-dropdown-placement-bottomLeft {
    width: 300px !important;
  }
  .ant-select-arrow {
    color: #606060;
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d4d4d4;
    background: #f5f5f5;
  }
  .ant-select-selection--single,
  .ant-select-selection--multiple {
    height: ${props => (props.stateModal ? '100%' : '40px')};
    width: ${props => (props.filterModal ? '100%' : 'auto')};
    min-height: 41px;
    display: flex;
    align-items: center;
    @media only screen and (min-width: 320px) and (max-width: 1023px) {
      width: 100%;
    }
  }
  .ant-select-selection__rendered {
    line-height: ${props => (props.primary ? '0' : null)};
  }
  .ant-select-selection--single .ant-select-selection__rendered > ul > li,
  .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    height: auto;
    max-width: 150px;
    margin-bottom: 3px;
    padding-top: 2px;
    line-height: normal;
  }

  .ant-select-dropdown-menu-item {
    color: ${props => props.theme.colors.tabHead};
    font-size: ${props => props.theme.fontSize.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
  
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: ${props => (props.filterModal ? '100%' : '79%')};
  }
  @media only screen and (min-width: 728px) and (max-width: 1023px) {
    /* margin-bottom: 30px; */
  }
  @media only screen and (min-width: 1023px) and (max-width: 1439px) {
    width: ${props => (props.filterModal ? '100%' : '300px')};
  }
`;

export const PlaceHolder = styled.div`
  margin-top: 2.5px;
  margin-left: 20px;
  font-family: HelveticaNeue;
  font-size: ${props => props.theme.fontSize.primary};
  color: #d4d4d4;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;
